import { onApplicationMenu, onTopLevelRoutes } from 'core';
import Router from './components/Router';

onTopLevelRoutes(() => ({
  path: '/tag',
  secure: true,
  component: Router,
}));

onApplicationMenu(() => ({
  group: 'stock',
  label: 'tags',
  icon: 'boxes',
  to: '/tag',
}));
